import { call, fork, put, take } from "redux-saga/effects";
import qs from "qs";

import {
  logoutSucces,
  initialLoadProcessed,
  logout,
  showVerifyAfterSignIn,
  showPage,
} from "./actions";

import apiService from "../../api/apiServices/apiService";
import { history } from "../../main";
import { findStats } from "../StatPage/actions";
import { getPokersiteIdByPokersiteName } from "../StatPage/utils";

function* watchLogout() {
  while (true) {
    yield take(logout.type);

    const { success } = yield call([apiService, apiService.logout]);

    if (success) {
      yield put(logoutSucces());
      history.push("/");
    }
  }
}

export default function* appSaga() {
  const { success } = yield call([apiService, apiService.user]);
  if (success) {
    yield put(showVerifyAfterSignIn(success.payload));
    if (history.location.pathname === "/") {
      history.push(`/statistics`);
    }

    if (history.location.pathname === "/statistics") {
      const querystring = qs.parse(history.location.search, {
        ignoreQueryPrefix: true,
      });

      if (querystring.playername && querystring.room) {
        const pokersiteId = getPokersiteIdByPokersiteName(
          querystring.room as string
        );
        if (pokersiteId) {
          yield put(showPage("StatPage"));
          yield put(
            findStats({
              playername: querystring.playername as string,
              pokersiteId,
            })
          );
        }
      }
    }
  }

  yield put(initialLoadProcessed(true));

  yield fork(watchLogout);
}
